import { createModalStore } from '@/shared/lib/modal';

type RecordingFeedbackBonusModalStore = Record<string, never>;

const initialState: RecordingFeedbackBonusModalStore = {};

export const useRecordingFeedbackBonusModalStore = createModalStore(initialState);
